import React from 'react';

import { Row, Col } from 'components/Grid';
import Benefit from './components/Benefit';

import {
  Section,
  Container
} from './styles';

const BENEFITS = () => {
  const colProps = { xs: 12, md: 6, lg: 3 };

  return (
    <Section>
      <Container>
        <Row align="start" justify="between" gutterWidth={20}>
          <Col {...colProps}>
            <Benefit name="SAVE" />
          </Col>
          <Col {...colProps}>
            <Benefit name="CONVENIENT" />
          </Col>
          <Col {...colProps}>
            <Benefit name="SELF-SERVICE" />
          </Col>
          <Col {...colProps}>
            <Benefit name="INTEGRATED" />
          </Col>
        </Row>
      </Container>
    </Section>
  );
};

export default BENEFITS;
